import { createAction, props } from '@ngrx/store';

export const loadUnits = createAction('[Employee] Load Units');
export const loadUnitsSuccess = createAction('[Employee] LoadUnits Success', props<{ payload: any }>());
export const loadUnitsFail = createAction('[Employee] Load Units Fail', props<{ payload: any }>());

export const loadMoreUnits = createAction('[Employee] Load More Units', props<{ payload: {skip: number, limit: number} }>());
export const loadMoreUnitsSuccess = createAction('[Employee] Load More Units Success', props<{ payload: any }>());
export const loadMoreUnitsFail = createAction('[Employee] Load More Units Fail', props<{ payload: any }>());

export const loadAllUnits = createAction('[Employee] Load All Units');
export const loadAllUnitsSuccess = createAction('[Employee]  Load All Units Success', props<{ payload: any }>());
export const loadAllUnitsFail = createAction('[Employee] Load All Units Fail', props<{ payload: any }>());

export const searchUnits = createAction('[Employee] Search Units', props<{ payload: any }>());
export const searchUnitsSuccess = createAction('[Employee] Search Units Success', props<{ payload: any }>());
export const searchUnitsFail = createAction('[Employee] Search Units Fail', props<{ payload: any }>());
